// extracted by mini-css-extract-plugin
var _1 = "EpostStatusTimelineContents-modulecontent__HJ0HI Container-modulecontent__hwVr6";
export { _1 as "content" }
